import { useEffect } from "react";

/**
 * Attaches an IntersectionObserver to every element with class "reveal"
 * and toggles the "visible" class when it scrolls into view.
 * Call once inside the top-level page component.
 */
export default function useReveal() {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));

    // clean up on unmount
    return () => observer.disconnect();
  }, []);
}
